export const gqlQueryJobHeaderServices = /* GraphQL */ `
  query gqlQueryJobHeaderServices($user_id: String!, $next_token: String) {
    listJobHeaderServices(user_id: $user_id, next_token: $next_token) {
      nextToken
      items {
        user_id
        job_id
        status
        service_type
        created
        modified
        premise {
          premise_id
          name
          type
          phase_type
          place {
            municipality
            region
          }
        }
      }
    }
  }
`;
